<template>
    <div :id="rootElementId" :style="`height:${height}px`" class="d-flex justify-center"></div>
</template>

<script>
import { getDataUrl } from "../../utils/functions";
export default {
  name: "DriblabSVGText",
  computed: {
    rootElementId() {
      return `driblabSVGText${this.id}`;
    },
    darkMode(){
      return this.$vuetify.theme.dark;
    }
  },
  props:{
    id:{
      required: true
    },
    height:{
      type:Number,
      default:100
    },
    width:{
      type: Number,
      default: 300
    },
    bgColor:{
      type: String,
      default: "white"
    },
    margin:{
      type: Object,
      required: false
    },
    text:{
      type: String,
      default: ""
    },
    textColor:{
      type: String,
      default: ""
    },
    align:{
      type: String,
      default:"middle"
    },
    justify:{
      type:String,
      default:"middle"
    },
    weight:{
      type:String,
      default:"100"
    },
    fontSize:{
      type:String,
      required: false
    }
  },
  data() {
    return {
      images:{}
    };
  },
  mounted: function() {
    window.addEventListener("resize", this.onWindowResize);
    this.printD3()
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  watch:{
    "width": function(newValue,oldValue){
      this.printD3();
    }
  },
  methods: {
    printD3(force = false){
      if(force){
        this.images = {}
      }
      let SVG_WIDTH = this.width ? this.width : this.$el.getBoundingClientRect().width; 

      d3.select(`#${this.rootElementId}`).select("svg").remove();

      var svg = d3.select(`#${this.rootElementId}`).append("svg")
      .attr("width", SVG_WIDTH)
      .attr("height", this.height)
      .style("fill", this.darkMode ? "cfcfcf" : "black")
      .style("background", this.bgColor)
      .attr("class", "driblabSVGText")
      .attr("id",`${this.rootElementId}SVG`)


      
      //INI --- DRAW
      let textSize = this.fontSize ? this.fontSize : ((SVG_WIDTH * 22) / 600);
      let textX = this.justify === 'middle' ? (SVG_WIDTH / 2) : 0;
      let textY = this.align === 'middle' ? (this.height / 2) + (textSize / 2) : 0;
      this.drawText(svg, textX,textY,this.textColor,textSize,this.weight,this.text,this.align)
      //END --- DRAW

    },
    drawImageBase64(svg,x,y,width,height,img,className,idName,bottom = false,extraParams={}) {
      if(!this.images[idName]){
        let base_image = new Image();
        base_image.crossOrigin = "anonymous";
        base_image.src = img;
        base_image.onload = (event) => {
          const dataUrl = getDataUrl(event.currentTarget);
          this.drawImage(
          svg,
          x,
          y,
          width,
          height,
          dataUrl,
          className,
          idName,
          bottom,
          extraParams
          );
        }
      }else{
        if(bottom){
          svg.node().insertBefore(this.images[idName],svg.node().firstChild);
        }else{
          svg.node().appendChild(this.images[idName]);
        }
      }
    },
    drawImage: function(svg, x, y, width, height, img,className,idName,bottom = false,extraParams={}) {
      let imgNode = bottom ? svg.insert("svg:image",":first-child") : svg.append("svg:image");
        imgNode.attr("x", x - (width / 2))
        .attr("y",  y - (height / 2))
        .attr("width", width)
        .attr("height", height)
        .attr("xlink:href", img)
        .attr("class",className)
        _.forEach(extraParams,(value,key) => {
          imgNode.attr(key,value);
        })
      this.images[idName] = imgNode.node().cloneNode(true);
    },
    drawRectangle(svg, x, y, width, height, color, opacity, className) {
      svg.append("rect")
        .attr("class", className)
        .attr("x", x)
        .attr("y", y)
        .attr("width", width)
        .attr("height", height)
        .style("fill", color)
        .style("opacity", opacity);
    },
    drawLine(svg, x, y, distance,size, color, opacity, className) {
      svg.append('line')
        .attr("class", className)
        .style("stroke", color)
        .style("stroke-width", size)
        .attr("x1", x - (distance/2))
        .attr("y1", y)
        .attr("x2", x + (distance/2))
        .attr("y2", y)
        .style("opacity", opacity);
    },
    drawCircle(svg, x, y, radius, fillColor,borderColor,borderSize, opacity, className) {
      return svg.append("circle")
        .attr("class", className)
        .attr("r", radius)
        .attr("cx", x)
        .attr("cy", y)
        .style("fill", fillColor)
        .style("stroke", borderColor)
        .style("stroke-width", borderSize)
        .style("opacity", opacity);
    },
    drawText(svg,x,y,color,fontSize,fontWeight,text,anchor="middle"){
      return svg.append("text")
      .attr("x",x)
      .attr("y",y)
      .attr("fill", color)
      .attr("font-size", fontSize)
      .attr("font-family", "NeueMontreal")
      .attr("font-weight", fontWeight)
      .style("text-anchor",anchor)
      .text(text);
    },
    onWindowResize(){
      setTimeout(() => this.printD3(true),100);
    }
  }
};
</script>
<style>
</style>
